let config = {
  // prod
  // HOST_NAME: "https://admin-myeslsca.azurewebsites.net",
  // API_BASE_URL: "https://admin-myeslsca.azurewebsites.net/api/",

  // for prod
  // SHAREQUESTPHRASE: "Sanjeev14",
  // SHARESPONSEPHRASE: "Sanjeev14",
  // ACCESSCODE: "aukicm0VNaCvqdPJByLF",
  // MERCHANTIDENTIFIER: "XpKsqQix",
  // PURCHASEHOSTURL: "https://checkout.payfort.com/FortAPI/paymentPage",
  // return_url:
  //   "https://admin-myeslsca.azurewebsites.net/api/payment/purchase/response",

  DYNAMIC_PAGE: true,

  //local
  // HTML_URL: "http://localhost:3000/MonUSB-2023-USB-pageHTML.html",
  // HOST_NAME: "http://localhost:3001",
  // API_BASE_URL: "http://localhost:3001/api/",
  // BASE_URL: "http://localhost:3000",

  //dev
   HTML_URL : "https://usb-dev.azurewebsites.net/MonUSB-2023-USB-pageHTML.html",
   HOST_NAME: "https://usb-devbackend.azurewebsites.net/",
   API_BASE_URL: "https://usb-devbackend.azurewebsites.net/api/",
  BASE_URL: "https://usb-dev.azurewebsites.net",

  INVALID_PASSWORD: "Invalid Username or Password",
  CONFIRM_PASSWORD: "Password and confirm Password didn't matched",

  // for dev
  SHAREQUESTPHRASE: "TESTSHAIN",
  SHARESPONSEPHRASE: "TESTSHAOUT",
  ACCESSCODE: "BVAqsy3vJF3OoTNMQMjU",
  MERCHANTIDENTIFIER: "ouWmOQdP",
  PURCHASEHOSTURL: "https://sbcheckout.payfort.com/FortAPI/paymentPage",
  //return_url: "http://localhost:3001/api/payment/purchase/response",
  return_url:
    "https://oneworldwebappcontainer.azurewebsites.net/api/payment/purchase/response",
  copyright: `© Université de Saint-Boniface ${new Date().getFullYear()} - Tous droits réservés.`,
};

// xs: Extra small screens (up to 599px)
// sm: Small screens (600px - 959px)
// md: Medium screens (960px - 1279px)
// lg: Large screens (1280px - 1919px)
// xl: Extra large screens (1920px and above)

export default config;
